import React, { memo } from "react";

import classnames from "classnames/dedupe";

import { TooltipContentType } from "components/gt-tooltip/gt-tooltip";
import { TooltipHOC } from "components/index";

interface IDefaultCellProps {
    children: TooltipContentType;
    tooltipContent?: TooltipContentType;
    value: string;
    className?: string;
}

const arePropsEqual = (prev, next) => {
    return prev.value == next.value && prev.tooltipContent == next.tooltipContent;
};

export const DefaultCell = memo(
    (props: IDefaultCellProps) => (
        <TooltipHOC
            tooltipContent={props.tooltipContent || props.children}
            disableTranslation
            className={classnames("cell-tooltip", props.className)}
        >
            {props.children}
        </TooltipHOC>
    ),
    arePropsEqual
);
